import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AdminReports } from "@/components/admin/AdminReports";
import {
  fetchReports,
  setReportStatus,
} from "@/adapters/supabase/reportSubmission";

/**
 * Where an administrator works through reports. Linked from nowhere: an
 * administrator is given the address, and anybody else who finds it is refused
 * by the API before a report is read.
 */
export const Route = createFileRoute("/admin/reports")({
  head: () => ({
    meta: [
      { title: "Reports — SyncAni" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: AdminReportsRoute,
});

function AdminReportsRoute() {
  const { t } = useTranslation();
  return (
    <main className="min-h-svh bg-background px-4 py-10">
      <div className="mx-auto w-full max-w-3xl space-y-6">
        <h1 className="text-xl font-semibold">{t("adminReports.title")}</h1>
        <AdminReports load={fetchReports} decide={setReportStatus} />
      </div>
    </main>
  );
}
